(() => {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => [...r.querySelectorAll(s)];

  const drawer = qs('#CartDrawer');
  const overlay = qs('.drawer-overlay');
  const body = document.body;

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    body.classList.add('cart-open');
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    body.classList.remove('cart-open');
  }

  qsa('[data-open-cart]').forEach((el) => el.addEventListener('click', (e) => {
    e.preventDefault();
    openCart();
    refreshCart();
  }));
  qsa('[data-close-cart]').forEach((el) => el.addEventListener('click', closeCart));

  const mobile = qs('#MobileNav');
  function openMenu() {
    mobile?.classList.add('is-open');
    mobile?.setAttribute('aria-hidden', 'false');
    body.classList.add('nav-open');
  }
  function closeMenu() {
    mobile?.classList.remove('is-open');
    mobile?.setAttribute('aria-hidden', 'true');
    body.classList.remove('nav-open');
  }
  qs('[data-open-menu]')?.addEventListener('click', openMenu);
  qsa('[data-close-menu]').forEach((el) => el.addEventListener('click', closeMenu));

  function money(cents, currency) {
    const n = (Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(n);
    } catch {
      return n.toFixed(2) + ' ' + (currency || '');
    }
  }

  async function changeLine(key, quantity) {
    const root = window.Shopify?.routes?.root || '/';
    const res = await fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    if (!res.ok) throw new Error('cart change failed');
    return res.json();
  }

  async function refreshCart() {
    const box = qs('[data-cart-body]');
    if (!box) return;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const cart = await fetch(root + 'cart.js').then((r) => r.json());
      const count = qs('[data-cart-count]');
      if (count) count.textContent = cart.item_count;
      if (!cart.items.length) {
        box.innerHTML = '<div class="cart-empty"><p>Your cart is empty.</p><a class="btn btn-gold btn-wide" href="/collections/all">Shop now</a></div>';
        return;
      }
      const lines = cart.items.map((item) => {
        const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-line__variant">${item.variant_title}</div>` : '';
        const img = item.image ? item.image.replace(/(\.jpg|\.png|\.webp)(\?|$)/, '_120x$1$2') : '';
        return `
        <div class="cart-line" data-cart-key="${item.key}">
          <img class="cart-line__img" src="${img || item.image || ''}" alt="" width="72" height="72">
          <div class="cart-line__info">
            <strong class="cart-line__title">${item.product_title}</strong>
            ${variant}
            <div class="cart-line__price">${money(item.final_line_price, cart.currency)}</div>
            <div class="cart-line__actions">
              <div class="cart-qty" role="group" aria-label="Quantity">
                <button type="button" class="cart-qty__btn" data-cart-qty="-1" data-key="${item.key}" aria-label="Decrease">−</button>
                <span class="cart-qty__val" data-qty-val>${item.quantity}</span>
                <button type="button" class="cart-qty__btn" data-cart-qty="1" data-key="${item.key}" aria-label="Increase">+</button>
              </div>
              <button type="button" class="cart-line__remove" data-cart-remove data-key="${item.key}" aria-label="Remove">Remove</button>
            </div>
          </div>
        </div>`;
      }).join('');
      box.innerHTML = `
        <div class="cart-lines">${lines}</div>
        <div class="cart-footer">
          <div class="cart-subtotal"><span>Subtotal</span><strong>${money(cart.total_price, cart.currency)}</strong></div>
          <a class="btn btn-gold btn-wide" href="/checkout">Checkout</a>
          <button type="button" class="btn btn-ghost btn-wide" data-close-cart>Continue shopping</button>
        </div>`;
      bindCartControls(box);
    } catch (err) {
      box.innerHTML = '<p>Cart preview is available after the theme is published on Shopify.</p>';
    }
  }

  function bindCartControls(box) {
    box.querySelectorAll('[data-cart-qty]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const key = btn.getAttribute('data-key');
        const delta = parseInt(btn.getAttribute('data-cart-qty'), 10) || 0;
        const line = btn.closest('.cart-line');
        const valEl = line?.querySelector('[data-qty-val]');
        let qty = parseInt(valEl?.textContent, 10) || 1;
        qty = Math.max(0, qty + delta);
        btn.disabled = true;
        try {
          await changeLine(key, qty);
          await refreshCart();
        } catch {
          await refreshCart();
        }
      });
    });
    box.querySelectorAll('[data-cart-remove]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        const key = btn.getAttribute('data-key');
        btn.disabled = true;
        try {
          await changeLine(key, 0);
          await refreshCart();
        } catch {
          await refreshCart();
        }
      });
    });
    box.querySelectorAll('[data-close-cart]').forEach((el) => el.addEventListener('click', closeCart));
  }

  document.querySelectorAll("form[data-add-to-cart], form[action*='/cart/add']").forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const data = new FormData(form);
      if (!data.get('id')) {
        window.location.href = '/collections/all';
        return;
      }
      try {
        const res = await fetch(window.Shopify?.routes?.root ? (window.Shopify.routes.root + 'cart/add.js') : '/cart/add.js', {
          method: 'POST',
          body: data,
          headers: { Accept: 'application/json' }
        });
        if (!res.ok) throw new Error('add failed');
        openCart();
        refreshCart();
      } catch (err) {
        form.submit();
      }
    });
  });

  qsa('[data-slider]').forEach((root) => {
    const track = qs('[data-track]', root);
    if (!track) return;
    qs('[data-prev]', root)?.addEventListener('click', () => {
      track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
    });
    qs('[data-next]', root)?.addEventListener('click', () => {
      track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
    });
  });

  // Product gallery thumbs
  qsa('[data-pdp-thumb]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const src = btn.getAttribute('data-src');
      if (!src) return;
      const gallery = btn.closest('.pdp-gallery') || document;
      const main = gallery.querySelector('#PdpMainImage, #PdpMainImageHome, .pdp-main img');
      if (main) main.src = src;
      const thumbs = gallery.querySelectorAll('[data-pdp-thumb]');
      thumbs.forEach((t) => t.classList.remove('is-active'));
      btn.classList.add('is-active');
    });
  });

  // Quantity steppers
  qsa('[data-qty-minus]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement?.querySelector('[data-qty-input], input[type="number"]');
      if (!input) return;
      const v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
    });
  });
  qsa('[data-qty-plus]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const input = btn.parentElement?.querySelector('[data-qty-input], input[type="number"]');
      if (!input) return;
      input.value = (parseInt(input.value, 10) || 1) + 1;
    });
  });

  // Purchase plan highlight
  qsa('[data-plan]').forEach((input) => {
    input.addEventListener('change', () => {
      qsa('.pdp-plan').forEach((el) => el.classList.remove('is-active'));
      input.closest('.pdp-plan')?.classList.add('is-active');
    });
  });

  // Bundle quantity selectors
  document.querySelectorAll('[data-bundle-root]').forEach((root) => {
    const form = root.closest('form') || root;
    const qtyInput = form.querySelector('[data-qty-input]');
    root.querySelectorAll('[data-bundle-opt]').forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        const q = parseInt(input.value, 10) || 1;
        if (qtyInput) qtyInput.value = q;
        root.querySelectorAll('.bundle-option').forEach((el) => el.classList.remove('is-active'));
        input.closest('.bundle-option')?.classList.add('is-active');
      });
    });
  });


  // Shopify variant packs: update id, price, main image
  document.querySelectorAll('[data-variant-packs]').forEach((root) => {
    const form = root.closest('form') || root.closest('.pdp-info') || document;
    const idInput = form.querySelector('[data-variant-id-input], input[name="id"]');
    const priceBox = document.querySelector('[data-price-box]') || form.parentElement?.querySelector('[data-price-box]');
    const mainImg = document.querySelector('[data-main-product-image], #PdpMainImage, #PdpMainImageHome');
    const addBtn = form.querySelector('[data-add-label]');

    root.querySelectorAll('[data-variant-opt]').forEach((input) => {
      input.addEventListener('change', () => {
        if (!input.checked) return;
        const id = input.getAttribute('data-variant-id');
        const price = input.getAttribute('data-variant-price');
        const compare = input.getAttribute('data-variant-compare') || '';
        const save = input.getAttribute('data-variant-save') || '';
        const image = input.getAttribute('data-variant-image') || '';
        const available = input.getAttribute('data-variant-available') !== 'false';

        if (idInput && id) idInput.value = id;

        root.querySelectorAll('.variant-pack').forEach((el) => el.classList.remove('is-active'));
        input.closest('.variant-pack')?.classList.add('is-active');

        if (mainImg && image) {
          mainImg.src = image;
          mainImg.style.opacity = '0.85';
          setTimeout(() => { mainImg.style.opacity = '1'; }, 120);
        }

        if (priceBox && price) {
          const main = priceBox.querySelector('[data-price-main]');
          const cmp = priceBox.querySelector('[data-price-compare]');
          const sav = priceBox.querySelector('[data-price-save]');
          if (main) main.textContent = price;
          if (cmp) {
            if (compare) { cmp.textContent = compare; cmp.hidden = false; }
            else { cmp.hidden = true; }
          }
          if (sav) {
            if (save) { sav.textContent = 'SAVE ' + save; sav.hidden = false; }
            else { sav.hidden = true; }
          }
        }

        if (addBtn) {
          addBtn.disabled = !available;
          addBtn.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
        }
      });
    });
  });

})();
